const MAX_RETRIES = 2;
const RETRY_DELAY_MS = 500;

const isTransient5xx = error => {
  const status = error?.response?.status;
  return typeof status === 'number' && status >= 500 && status < 600;
};

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export default function httpRetry(requestFn, { maxRetries = MAX_RETRIES, delayMs = RETRY_DELAY_MS } = {}) {
  const attempt = async (current = 0) => {
    try {
      return await requestFn({ ignoreInternalError: current < maxRetries });
    } catch (error) {
      if (isTransient5xx(error) && current < maxRetries) {
        await wait(delayMs * 2 ** current);
        return attempt(current + 1);
      }
      throw error;
    }
  };

  return attempt();
}
